import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import MediaTagListForm from '@src/features/tenant/mediaTags/MediaTagListForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function MediaTagList() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.ENTERPRISE_PORTAL]}
    >
      <TenantDefaultLayout>
        <CommonHelmet />
        <MediaTagListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default MediaTagList;
